<template>
  <div class="confirm">
    <v-btn class="register" :class="!isMobile ? 'btnMargin' : ''" color="primary white--text" rounded
      @click="$emit('nextStep')" :disabled="apiRunning">
      {{ lastStep ? "تایید و ارسال" : "مرحله بعد" }}
    </v-btn>
    <v-btn v-if="showCancel" class="register" color="primary white--text" rounded @click="$emit('prevStep')">
      مرحله قبل
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ["lastStep", "showCancel"],
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
};
</script>
<style scoped></style>
